import { get as _get } from "lodash";
import api from "../../helpers/api";

export const getStrategicAnalysisList = (variables) => {
  return api().options("/client/get_strategic_insight_report_list", { data: (variables || {}) }).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Strategic Analysis reports fetched successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching strategic analysis list."),
      data: {},
    };
  });
};

export const deleteStrategicAnalysis = (analysisId) => {
  return api().delete(`/client/strategic_analysis/${(analysisId || 0)}`).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Strategic Analysis report deleted successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while deleting strategic analysis."),
      data: {},
    };
  });
};

export const getStrategicAnalysisCron = (analysisId) => {
  return api().get(`/client/get_strategic_insight_report/${(analysisId || 0)}`).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Strategic Analysis report details fetched successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching strategic analysis details."),
      data: {},
    };
  });
};

export const saveStrategicAnalysis = (variables) => {
  return api().post("/client/save_strategic_insight_report", variables).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Strategic Analysis report saved successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while saving strategic analysis."),
      data: {},
    };
  });
};

export const getStrategicInsightReportTemplate = (clientId) => {
  return api().get(`/client/get_strategic_insight_report_template`, { params: { client_id: clientId } }).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Report templates fetched successfully."),
      data: _get(res, "data.responseData", []),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching report templates."),
      data: [],
    };
  });
};

export const getStrategicAnalysisReport = (analysisId) => {
  return api().get(`/client/get_strategic_insight_report_result/${(analysisId || 0)}`).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Strategic Analysis report fetched successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching strategic analysis report."),
      data: {},
    };
  });
};

export const uploadStrategicPromptFile = (variables, setParentState = null) => {
  const config = {
    onUploadProgress: (data) => {
      if (typeof setParentState === "function") {
        setParentState({
          promptFileUploadProgress: Math.round((100 * (data.loaded || 0)) / (data.total || 0))
        });
      }
    }
  };

  return api().post("/upload/file_strategic_prompt", variables, config).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "File uploaded successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while uploading the prompt file."),
      data: {},
    };
  });
};

export const publishStrategicInsightReport = (variables) => {
  return api().options("/client/publish_strategic_insight_report", { data: variables }).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Strategic Analysis report publish status updated successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while updating publish status."),
      data: {},
    };
  });
};
